import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1000 1000" {...props}><rect width="100%" height="100%" fill="transparent" /><path d="M3974 4585c377-433 759-858 1143-1293 407 282 652 505 847 826 239 394 147 693 19 877-197 281-446 556-756 767-328-527-634-865-1253-1177" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.66 -626.447)" /><path d="M2221 6745c705-352 1754-693 2704-740 365-19 645-21 928 71 62 20 119 47 172 83 206 142 110 455-174 363-384-126-639-165-1092-155-770 18-1692 147-2538 378" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "evenodd",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.453 -626.765)" /><path d="M6164 7529c4-13 14-15 28-7 81 50 122 115 122 197-3 62-16 116-39 163-23 46-47 81-70 105-41 41-101 72-178 91-9 2-17 3-23 3-7 0-11-2-11-6 0-6 11-18 34-34 45-32 88-68 128-108 38-39 57-64 57-77 0-32-36-78-108-137q-19.5-15-12-39c19-37 43-87 72-151" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.897 -626.945)" /><path d="M5938 7509c-1 45-2 86-2 122-1 37-3 67-6 93-5 54-16 102-31 143-16 42-29 70-38 84s-16 24-22 30c-7 7-12 8-16 6-3-2-5-6-3-10 0-2 3-21 11-58 7-36 12-72 14-107 2-34 2-83 1-147-1-63 0-111 4-144 3-20 7-40 13-61 6-20 13-41 21-61 7-20 15-39 23-57l24-48c5-9 10-12 15-10 4 2 6 5 6 10-2 5-3 17-5 35-1 19-3 40-4 63s-2 45-3 67-2 39-2 50" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.876 -626.917)" /><path d="M5880 7004c0-14 11-44 35-90s39-69 46-69c14-6 34 5 60 31 27 27 41 48 43 63q0 30-33 87t-48 57c-4-2-17-11-40-26-22-14-39-25-49-33-10-6-14-13-14-20" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.884 -626.865)" /><path d="M5032 6690q0-9 36-84c23-49 39-74 46-74 17 0 37 11 58 32 22 24 32 47 32 69 0 21-10 50-29 86-20 37-35 55-44 55-6 0-19-9-38-26-20-17-35-30-45-37-10-8-16-15-16-21" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.784 -626.828)" /><path d="M4946 6924c0-8 14-36 41-86 26-50 43-75 49-75 10 0 26 10 48 28s36 35 44 52q21-34.5 39-66c18-31 30-46 34-46 15 0 35 11 58 32 22 24 34 47 34 67 0 23-12 52-34 86-23 34-40 50-50 50-8 0-20-8-35-23-21-22-38-38-52-48-34 70-62 105-81 105-4 0-21-11-50-35-30-23-45-37-45-41" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.774 -626.852)" /><path d="M5223 7730c-9 28-14 46-16 52-26 70-46 116-59 138q-58.5 90-147 90c-41 0-72-19-93-59-20-39-30-96-30-169 0-30 5-82 17-157q18-118.5 30-192c9-54 18-101 26-142 7-43 15-76 24-98l58-120c2-3 5-4 8-2 2 2 3 7 3 14-1 7-3 22-7 46 0 0-13 84-37 250-8 46-14 83-18 112-3 28-6 48-7 59 8 0 61-57 158-169 147-169 235-270 266-305q55.5-63 99-111c28-33 52-60 70-82 79-94 143-180 192-259 11-15 17-22 19-21 1 1 2 5 1 13-10 36-15 55-16 58-15 39-36 79-64 122-17 30-43 68-78 113-32 43-79 100-141 172-1 1-33 36-94 104-20 22-40 45-60 68s-40 46-59 70l-105 122-95 108s1 0 1 1h3l128 27c9 3 17 5 25 7 8 3 17 5 25 7 37 11 62 16 75 16s34-16 62-49q22.5-28.5 33-42c8-4 27 2 42 0 20-3 35-36 48-51 5-5 8-7 11-8 6 1 16 3 29 7 5-1 16-11 32-32l19-26c17 0 15 12 31 3 9-4 17-12 21-21 7-21 2-46 2-68v-33c10-26 22-52 36-77 15-25 26-45 34-58 1-3 4-6 9-10 8 0 1 129-1 144-3 31-15 66-37 106s-43 69-64 89c-7 7-16 14-24 20-6 4-11 7-15 10-5 3-10 6-14 9-18 12-28 20-30 22-7 6-15 12-24 16l-30 12c-11 5-24 22-35 28l-53 30c-7 4-18 15-34 33-17 18-32 30-46 37-25 13-37 2-62-9-9-4-17-6-25-6-7 2-16 35-17 41m-42-30q0-31.5-39-48c-26-11-60-17-102-17-23 0-37 2-44 6-23 10-35 33-35 69 0 35 9 62 27 82 16 17 36 25 62 25 39 0 72-13 95-39 24-27 36-52 36-78" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.766 -626.837)" /><path d="M5604 6740c4 1 2 10-6 28-1 7-6 16-12 27-20 34-58 81-115 142-13 13-26 25-38 37-13 12-25 24-37 36 5-13 10-26 17-41 5-9 15-23 30-41 42-45 74-81 96-106 30-36 52-63 65-82" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.827 -626.853)" /><path d="M4837 7732c0 27-4 57-14 91-9 34-21 64-35 91-23 43-46 76-70 99s-51 34-80 34c-47 0-70-28-70-85 0-19 3-40 9-62 8-23 19-45 31-65 12-21 22-37 30-51-8-3-13-4-15-5s-4-1-5-1c-1-5 3-19 12-41l67-152c7-15 14-23 22-23 6 0 16 4 29 12s24 15 32 21c21 19 36 37 44 54 9 18 13 46 13 83m-91 149c0-18-7-33-19-44-7-7-16-14-27-21-12-7-21-11-29-13-6 0-16 11-30 34-14 22-21 40-21 55 0 28 17 43 51 43 15 0 31-6 48-17 18-11 27-23 27-37" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.73 -626.95)" /><path d="M4792 7191c1-21-13-39-37-46-40-13-84 8-86 55-1 18 23 29 66 33 35 4 56-10 57-42m-1932 677c-75-1-188-2-212 0-53 5-90 21-121 57-31 37-69 83-113 140-43 56-88 105-133 146s-83 71-113 91c-29 20-57 36-82 50s-52 26-81 37c-2 1-5 2-9 4-5 1-10 3-15 5-11 3-20 4-27 0-2-3 1-9 9-17 9-9 26-25 53-43 30-19 65-41 103-69s77-62 117-101c40-40 76-87 114-138 15-22 32-43 48-66 55-75 92-121 108-139 49-54 85-82 131-108 52-29 285-17 337-17 36-1 73 0 110 0 150-1 593-9 820-99 237-94 466-244 547-306 1 0-3-25-3-50 0-43 14-52 37-84l37-54c2-2 2-3 4-7 5-14 11-28 16-42 5-11 7-15 13-25l30-46 19 23c17 21 73 50 161 92 48 22 55 29 55 61 0 75-2 117-40 136-15 8-34 13-54 14l-112 4c-27 1-69 8-109 42-162 135-333 268-564 369-334 147-651 160-951 143-43-2-87-2-130-3m1785-692c0-32-17-49-45-54-17-3-29-3-44 6-29 19-66 68-45 88 10 10 27 18 47 20 53 6 86-21 87-60" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.421 -626.882)" /><path d="M2620 7095c0-14 12-44 35-90 24-47 39-70 47-70 13-5 33 5 60 32q39 40.5 42 63c0 20-11 49-33 86q-33 57-48 57c-4-2-17-10-39-25s-39-26-50-34c-9-6-14-12-14-19" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1927 0 0 .1927 -296.5 -626.876)" /></svg>;
export default Component;
export { Component as ReactComponent };